import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Actions from "../Redux/action";
import { BASE_URL, SUSPICIOUS_IMAGE} from "../Redux/saga/EndPoints";
import { toast } from "react-toastify";
import moment from "moment";
import nodatafound from '../asset/img/datanotfound_black.png';
import AppDatePicker from "../component/AppDatePicker";
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
import AppLoader from "../component/AppLoader";
import { getCollegeList, getCourseList, getSlotList, getYearList, getdepartmentList, getdepartmentSearch } from "../Redux/reducer/SchedulerReducer";
import { getHostelListSelectSelector } from "../Redux/reducer/HostelReducer";
import { ViewNotificationImagePopup } from "../component/ViewNotificationImage";
import { PaginationComponent } from "../component/PaginationComponent";
export const NotificationList = () => {
    const EXCEL_EXTENSION = '.xlsx'
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const dispatch = useDispatch();
    const hostelList = useSelector(getHostelListSelectSelector)
    const defaultTimeState = {
        start_time: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
        end_time: moment()
    };
    const [formDetails, setFormDetails] = useState({ ...defaultTimeState })
    const [err, setErr] = useState({})
    const [viewReports, setViewReport] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [popup, setPopup] = useState(false);
    const [notificationList, setNotificationList] = useState([]);
    const [popupData, setPopupData] = useState();
    const [fromDate, setFromDate] = useState('')
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [pagination, setPagination] = useState({
        count: 0,
        next: null,
        previous: null,
        pageSize: 10
    });

      const [count, setCount] = useState(0);

const onChangeHandle = (newPage) => {
    setPageNumber(newPage);
    window.scrollTo({ top: 0, behavior: 'smooth' });
};
    useEffect(() => {
        viewReport()

    }, [dispatch])

    const getHostelList = useCallback(() => {
        // let params = {
        //     page: pageNumber
        // }
        dispatch(Actions.hostelListSelect(""))
    }, [dispatch])

    useEffect(() => {
        getHostelList()
    }, [])

    const onClosePopUp = () => {
        setPopupData('')
        setPopup(false)
    }

    const clearReport = () => {
        setFromDate("")
        setErr("")
        setViewReport("")
        dispatch(Actions.clearReports())
        setFormDetails({ hostel_id: "", ...defaultTimeState })
        // dispatch(Actions.clearRooms())
           setPageNumber(1)
    setCount(0)

    }
const viewReport = () => {
    if (!formDetails?.hostel_id) {
        setErr({ "hostel_id": "Please select the hostel" })
    } else if (!fromDate) {
        setErr({ "fromDate": "Please select the Date" })
    }
    else {
        const callback = (response) => {
            if (response) {
                if (response?.results?.length > 0) {  // Note: response.results (plural)
                    setNotificationList(response.results)
                    setCount(response.count)  // Set total count for pagination
                    setViewReport(true)
                } else {
                    toast.error("No data found")
                    setNotificationList([])
                    setCount(0)
                }
                setLoading(false)
                setErr("")
            }
            else {
                toast.error(response?.message)
                setLoading(false)
            }
        }

        let st_time = moment(fromDate).format('YYYY-MM-DD')
        const params = {
            hostel_id: formDetails?.hostel_id,
            start_time: moment(formDetails?.start_time).format("HH:mm:ss"),
            end_time: moment(formDetails?.end_time).format("HH:mm:ss"),
            date: st_time,
            page: pageNumber,  // Add page parameter
            page_size: pageSize  // Optional: add page size
        }
        setLoading(true)
        dispatch(Actions.notificationList(params, callback))
    }
}
    // const viewReport = () => {
    //     if (!formDetails?.hostel_id) {
    //         setErr({ "hostel_id": "Please select the hostel" })
    //     } else if (!fromDate) {
    //         setErr({ "fromDate": "Please select the Date" })
    //     }
    //     else {
    //         const callback = (response) => {
    //             if (response) {
    //                 if (response?.length > 0) {
    //                     setNotificationList(response)
    //                     // console.log(response.results, 'resulrs')
    //                     setViewReport(true)
    //                 } else {
    //                     toast.error("No data found")
    //                 }
    //                 setLoading(false)
    //                 setErr("")
    //             }
    //             else {
    //                 toast.error(response?.message)
    //                 setLoading(false)
    //             }
    //         }

    //         let st_time = moment(fromDate).format('YYYY-MM-DD')
    //         const params = {
    //             hostel_id: formDetails?.hostel_id,
    //             start_time: moment(formDetails?.start_time).format("HH:mm:ss"),
    //             end_time: moment(formDetails?.end_time).format("HH:mm:ss"),
    //             date: st_time,
    //             // page: pageNumber
    //         }
    //         setLoading(true)
    //         dispatch(Actions.notificationList(params, callback))
    //     }
    // }

    // const handleClick = (url) => {
    //     setPopup(true);
    //     setPopupData(url)

    // }

    const handleClick = (img_path) => {
     if (!img_path) {
        toast.error("Image not available");
        return;
    }

    const url = `${BASE_URL}${SUSPICIOUS_IMAGE}?img_path=${encodeURIComponent(img_path)}`;


            setPopupData(url); 
            setPopup(true);
       
};


    const handleHostelSelect = (selected) => {
        setViewReport(false)
        setFormDetails({ ...formDetails, 'hostel_id': parseInt(selected) })
        setErr({ ...err, "hostel_id": "" })
        // viewReport(parseInt(selected))
    };

    const getDefaultTimesForDate = (date) => {
        if (!date) return defaultTimeState;
        const isToday = moment(date).isSame(moment(), 'day');
        return {
            start_time: moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
            end_time: isToday ? moment() : moment(date).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }),
        };
    };
    const handleDateSelect = (selected) => {
        setFromDate(selected);
        setFormDetails((prev) => ({ ...prev, ...getDefaultTimesForDate(selected) }));
        setViewReport(false);
        setErr("");
    };

    // Call viewReport when pageNumber changes
useEffect(() => {
    if (formDetails?.hostel_id && fromDate) {
        viewReport();
    }
}, [pageNumber]);

// Reset to page 1 when filters change
useEffect(() => {
    setPageNumber(1);
}, [formDetails?.hostel_id, fromDate]);

    const handleTimeChange = (value, time) => {
        if (value) {
            if (time === "start_time") {
                setFormDetails({ ...formDetails, [time]: value })
            } else {
                setFormDetails({ ...formDetails, [time]: value })
            }
        }
    }

    const disabledEndMinutes = (selectedHour) => {
        const startMinute = formDetails?.start_time ? moment(formDetails.start_time).minute() : 0;
        const startHour = formDetails?.start_time ? moment(formDetails.start_time).hour() : 0;
        if (selectedHour === startHour) {
            let minutes = [];
            for (let i = 0; i < startMinute; i++) {
                minutes.push(i);
            }
            return minutes;
        }
        return [];
    }

    const disabledEndHours = () => {
        const startHour = formDetails?.start_time ? moment(formDetails.start_time).hour() : 0;
        let hours = [];
        for (let i = 0; i < startHour; i++) {
            hours.push(i);
        }
        return hours;
    }

    return (
        <>
            {
                isLoading && <AppLoader />
            }
            <div className="ecommerce-widget">
                <h5 className="card-header">Notifications</h5>
                <div className="card border-3 border-top border-top-primary">
                    <div className="row">
                        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-6 selectDate mx-3">
                            <label htmlFor="exampleInputEmail1" className="form-label">Hostel <span className="text-danger">*</span></label>
                            <select value={formDetails?.hostel_id} onChange={(e) => handleHostelSelect(e?.target?.value)}
                                className="form-select">
                                <option value='' hidden>Select Hostel</option>
                                {Array.isArray(hostelList) && hostelList?.map((o) => {
                                    return <option value={o?.id}>{o?.name}</option>
                                })
                                }
                            </select>
                            <p style={{ 'color': 'red' }}>{err?.hostel_id}</p>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">Date <span className="text-danger">*</span></label>
                            <div className="input-group mb">
                                <AppDatePicker
                                    disabled={!formDetails?.hostel_id}
                                    selected={fromDate && moment(fromDate).isValid() ? moment(fromDate).toDate() : null}
                                    placeholder="Date"
                                    maxDate={new Date()}
                                    onChange={(date) => {
                                        handleDateSelect(date)
                                    }}
                                    notValidTime={true}
                                    id='FormDatePicker'
                                />
                            </div>
                            <p style={{ 'color': 'red' }}>{err?.fromDate}</p>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">Start Time</label>
                            <div className="input-group w-75">
                                <TimePicker showSecond={false} format={'HH:mm'} disabled={!fromDate} onChange={(v) => handleTimeChange(v, "start_time")} value={formDetails?.start_time ?? defaultTimeState.start_time} disableClock={true} className="form-control  cursor-pointer" />
                            </div>
                            {/* <p style={{ 'color': 'red' }}>{err?.hostel}</p> */}
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">End Time</label>
                            <div className="input-group w-75">
                                <TimePicker showSecond={false} format={'HH:mm'} disabled={!fromDate} clearIcon={false} onChange={(v) => handleTimeChange(v, "end_time")} value={formDetails?.end_time ?? defaultTimeState.end_time} disableClock={true} className="form-control dateInput cursor-pointer" disabledHours={disabledEndHours}
                                    disabledMinutes={disabledEndMinutes} />
                            </div>
                            {/* <p style={{ 'color': 'red' }}>{err?.end_time}</p> */}
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12 selectDate1">
                            <button type="button" className="btn btn-primary" onClick={() => viewReport()}>View</button>

                            &nbsp;
                            {(fromDate || hostelList?.length > 0) && <button className="btn btn-primary" onClick={() => clearReport()}>Clear</button>}
                        </div>
                    </div>

                </div>
                <div className="card">
                    <div className="card-body p-0">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="table-responsive">
                                    {/* {
                                        (Array.isArray(notificationList)) && <h4 className="mt-2 p-2">Presents-{Presentees?.length}</h4>
                                    } */}
                                    {(Array.isArray(notificationList) && notificationList?.length > 0) &&
                                        <table className="table onboardTable">
                                            <thead className="bg-light">
                                                <tr className="border-0">
                                                    <th className="border-0">S.No</th>
                                                    <th className="border-0">Date</th>
                                                    <th className="border-0">Time</th>
                                                    <th className="border-0">Camera</th>
                                                    <th className="border-0">Hostel</th>
                                                    <th className="border-0">Message</th>
                                                    <th className="border-0">Suspicious ID</th>
                                                    <th className="border-0">Image</th>
                                                    {/* <th className="border-0">Room</th> */}

                                                    {/* <th className="border-0">Remarks</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(Array.isArray(notificationList) && notificationList?.length > 0) && notificationList?.map((item, index) => {
                                                    return <tr>
                                                        {/* <td>{index + 1}</td> */}
                                                        <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                                                        <td>{moment(item?.time).format('YYYY-MM-DD')}</td>
                                                        <td>{moment(item?.time).format('HH:mm:ss')}</td>
                                                        <td>{item?.camera}</td>
                                                        <td>{item?.hostel}</td>
                                                        <td>{item?.message}</td>
                                                        <td>{item?.tracker_id}</td>
                                                        {item?.video_url && <td>
                                                            <button type="button" className="btn btn-primary" onClick={() => handleClick(item?.video_url)}>View</button>
                                                        </td>}

                                                    </tr>
                                                })}
                                                <tr>
                                                    <td colspan="9">
                                                        <PaginationComponent onChangeHandle={onChangeHandle} pageCount={count} pageNumber={pageNumber} setpage={setPageNumber} />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>}
                                    {notificationList?.length === 0 && <div className="d-flex justify-content-center mt-5 mb-5">
                                        <div className="NodataFound mb-3">
                                            <h3>No Data Found</h3>
                                        </div>
                                        <div className="NodataImage">
                                            <img src={nodatafound} alt="No Data Found" className="NoData" />
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

           {
                popup && <ViewNotificationImagePopup onClose={() => onClosePopUp(false)} data={popupData} />

            }

        </>
    )
}